import AppLayout from "../components/layout/AppLayout";
import { ROUTES } from "../constant/routes";
import BranchManagement from "../pages/admin/Branch";
import Business from "../pages/admin/Business";
import Calendar from "../pages/admin/Calendar";
import Dashboard from "../pages/admin/Dashboard";
import Advisor from "../pages/admin/Advisor";
import Topics from "../pages/admin/Topics";
import Users from "../pages/admin/Users";
import Team from "../pages/admin/Team";
import Chats from "../pages/admin/Chats";
import Customers from "../pages/admin/Customers";
import Documentation from "../pages/admin/Documentation";
import MeetingRoom from "../pages/admin/MeetingRoom";
import Subscriptions from "../pages/admin/Subscriptions";
import Poster from "../pages/admin/Poster";
import Spreadsheet from "../pages/admin/Spreadsheet";
import Excel from "../pages/admin/Excel";
import OpenSign from "../pages/admin/OpenSign";
import Tasks from "../pages/admin/Tasks";
import WorkFlow from "../pages/admin/Workflow";

const protectedRouter = [
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        path: ROUTES.DASHBOARD,
        element: <Dashboard />,
      },
      {
        path: ROUTES.BUSINESS,
        element: <Business />,
      },
      {
        path: ROUTES.BRANCH,
        element: <BranchManagement />,
      },
      {
        path: ROUTES.CUSTOMERS,
        element: <Customers />,
      },
      {
        path: ROUTES.ADVISOR,
        element: <Advisor />,
      },
      {
        path: ROUTES.USERS,
        element: <Users />,
      },
      {
        path: ROUTES.CALENDAR,
        element: <Calendar />,
      },
      {
        path: ROUTES.TOPICS,
        element: <Topics />,
      },
      {
        path: ROUTES.TEAM,
        element: <Team />,
      },
      {
        path: ROUTES.POSTER,
        element: <Poster />,
      },
      {
        path: ROUTES.CHATS,
        element: <Chats />,
      },
      {
        path: ROUTES.DOCUMENTATION,
        element: <Documentation />,
      },
      {
        path: ROUTES.SPREADSHEET,
        element: <Spreadsheet />,
      },
      {
        path: `${ROUTES.EXCEL}/:workbook_id`,
        element: <Excel />,
      },
      {
        path: ROUTES.BILLING,
        element: <Subscriptions />,
      },
      {
        path: ROUTES.OPENSIGN,
        element: <OpenSign />,
      },
      {
        path: ROUTES.TASKS,
        element: <Tasks />,
      },
      {
        path: "workflow",
        element: <WorkFlow />,
      },
    ],
  },
  {
    path: `${ROUTES.MEETING_ROOM}/:roomId`,
    element: <MeetingRoom />,
  },
];

export default protectedRouter;
